import { ValueOf } from '@/types/util';

export const bankPayRefundFlag = {
  NORMAL: '返品可',
  ABNORMAL: '返品不可',
} as const;

export type BankPayRefundFlagKey = keyof typeof bankPayRefundFlag;
export type BankPayRefundFlagValue = ValueOf<typeof bankPayRefundFlag>;

export const bankPayRefundFlagKeys = Object.keys(bankPayRefundFlag) as BankPayRefundFlagKey[];

/** v-select用items */
export const bankPayRefundFlagItems = bankPayRefundFlagKeys
  .map((key) => ({
    title: bankPayRefundFlag[key],
    value: key,
  }));
